import { render } from "./AddVotersGroup.vue?vue&type=template&id=425c5697&scoped=true"
import script from "./AddVotersGroup.vue?vue&type=script&lang=js"
export * from "./AddVotersGroup.vue?vue&type=script&lang=js"

import "./AddVotersGroup.vue?vue&type=style&index=0&id=425c5697&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425c5697"]])

export default __exports__